export default __webpack_public_path__ + "static/media/LOGO BOTTOM.3bb1df27.png";